import { render, staticRenderFns } from "./VendorFormFields.vue?vue&type=template&id=baea9a40&scoped=true&"
import script from "./VendorFormFields.vue?vue&type=script&lang=js&"
export * from "./VendorFormFields.vue?vue&type=script&lang=js&"
import style0 from "./VendorFormFields.vue?vue&type=style&index=0&id=baea9a40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baea9a40",
  null
  
)

export default component.exports